import ExamSchedulePage from "../components/pages/ExamSchedule";

export default ExamSchedulePage;